// Temporary draft gate for the Cultural Governance Committee page.
// The page stays reviewable in the Emergent preview but is hidden on the
// live custom domain until the owner confirms the final wording and members.
// TO PUBLISH: delete this file and render the route/links/section
// unconditionally (see the TO PUBLISH note in pages/CulturalGovernance.jsx).
export const SHOW_GOVERNANCE =
  typeof window !== "undefined" && !/(^|\.)ngawilyinarrative\.com\.au$/.test(window.location.hostname);
